import React from 'react'
import { Content as TextContent } from './Text'
import * as styles from './styles.module.scss'

/**
 *
 */
const Container = ({ children, id }) => (
  <div className={styles.Container}>
    <a href={`https://www.arch-log.com/products/00/${id}/`} target="_blank">
      {children}
    </a>
  </div>
)

/**
 *現在imgタグで埋め込んでいるが、Gatsbyのイメージプラグインを使うのが理想
 */
const Image = ({ imageUrl }) => {
  return (
    <div className={styles.Container_Image}>
      <img src={imageUrl} className={styles.Container_Image} />
    </div>
  )
}

/**
 *
 */
const Text = ({ publishInfoShortLabel, productCode }) => (
  <div className={styles.Container_TextContent}>
    <TextContent
      publishInfoShortLabel={publishInfoShortLabel}
      productCode={productCode}
    />
  </div>
)

/**
 *
 */
export const Content = ({ entry }) => {
  if (entry) {
    return (
      <Container id={entry.id}>
        <Image imageUrl={entry.image} />
        <Text
          publishInfoShortLabel={entry.publishInfoShortLabel}
          productCode={entry.productCode}
        />
      </Container>
    )
  }
  return <></>
}
